import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as SecondaryNavActions from "./store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import { animations } from "react-animation";
import "./SecondaryNavBar.css";

function SecondaryNavBar(props) {
  const [logos, setLogos] = useState([]);
  const [showH1, setShowH1] = useState(false);
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");
  const isXSmall = useMediaQuery("(max-width: 374px)");

  let location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    location.pathname === "/" ? setShowH1(true) : setShowH1(false);
  }, [location]);

  const { contentNavbar } = useSelector(
    ({ SecondaryNavBar }) => SecondaryNavBar.SecondaryNavbar
  );

  useEffect(() => {
    if (contentNavbar) {
      setLogos(contentNavbar?.aCBarraSecundariaLogo);
    }
  }, [contentNavbar]);

  useEffect(() => {
    !contentNavbar && dispatch(SecondaryNavActions.getSecondaryNavContent());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Styles
  const contenedorStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "d-flex flex-column";
    }
    if (isIphoneX) {
      cls = "d-flex flex-column";
    }
    if (isIpadPortrait) {
      cls = "d-flex justify-content-between";
    }
    if (isIpadLandscape) {
      cls = "d-flex justify-content-between";
    }
    if (isMidLaptop) {
      cls = "contenedordesktop d-flex justify-content-between";
    }
    if (isFullHD) {
      cls = "contenedordesktop d-flex justify-content-between";
    }
    if (is4K) {
      cls = "contenedor d-flex justify-content-between";
    }
    return cls;
  };

  const curSiteStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "d-flex flex-column";
    }
    if (isIphoneX) {
      cls = "d-flex flex-column";
    }
    if (isIpadPortrait) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (isIpadLandscape) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (isMidLaptop) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (isFullHD) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (is4K) {
      cls = "d-flex justify-content-between align-items-center";
    }
    return cls;
  };

  const curLogoStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "mx-auto curlogo";
    }
    if (isIphoneX) {
      cls = "mx-auto curlogo";
    }
    if (isIpadPortrait) {
      cls = "curlogo_ipad";
    }
    if (isIpadLandscape) {
      cls = "curlogo_ipad";
    }
    if (isMidLaptop) {
      cls = "curlogo";
    }
    if (isFullHD) {
      cls = "curlogo";
    }
    if (is4K) {
      cls = "curlogo";
    }
    return cls;
  };

  const root = process.env.REACT_APP_CMS_STATIC;
  
  return (
    <section
      id="secondaryNavigationBar"
      name="secondaryNavigationBar"
      className="maincontentwhite"
    >
      <div
        className={contenedorStyle()}
        style={{ animation: animations.fadeIn }}
      >
        <div className={curSiteStyle()}>
          {logos.length > 0 && (
            <a key="logo" href={logos[0].url.url}>
              <img
                alt={logos[0].textoalternativo}
                src={root + logos[0].imagen.urls[0]}
                className={curLogoStyle()}
              />
            </a>
          )}
        </div>
      </div>
      {showH1 && (
        <h1 style={{ fontSize: "0", margin: "0" }}>Grupo CS Coopeservidores</h1>
      )}
    </section>
  );
}

export default SecondaryNavBar;
